{
  "voluntaryChange": {
    "review": {
      "travelExtras": {
        "title": "About your travel extras"
      },
      "confirm": {
        "title": "Confirm your changes"
      },
      "passengers": {
        "title": "Passengers"
      }
    }
  },
  "modifyYourTrip": {
    "upgrade": {
      "available": {
        "title": "Upgrade your travel class",
        "detail": "Get more perks, space and meal options.",
        "ctaButtonLabel": "Upgrade now"
      },
      "unavailableGeneric": {
        "title": "Upgrade unavailable at the moment",
        "detail": "Travel class upgrades are not available for your booking."
      },
      "unavailableNoLogin": {
        "title": "Upgrade unavailable at the moment",
        "detail": "Upgrades may come available {daysBeforeDepartureForMoneyUpgrade} days before departure. Log in to your Finnair Plus account to view waitlist options for your flights."
      },
      "unavailableNotEnoughAvios": {
        "title": "Upgrade unavailable at the moment",
        "detail": {
          "singular": "Right now, upgrades are available only with Avios. Paid upgrades may open in {daysUntilAvailable} day, depending on availability. You can also purchase more Avios.",
          "plural": "Right now, upgrades are available only with Avios. Paid upgrades may open in {daysUntilAvailable} days, depending on availability. You can also purchase more Avios."
        }
      },
      "unavailablePointPaymentNotAllowed": {
        "title": "Upgrade unavailable at the moment",
        "detail": {
          "singular": "Paid upgrades may come available in {daysUntilAvailable} day, depending on availability.",
          "plural": "Paid upgrades may come available in {daysUntilAvailable} days, depending on availability."
        }
      },
      "waitlist": {
        "title": "Waitlist for travel class upgrade",
        "detail": "Your travel class will be upgraded automatically when seats become available.",
        "ctaButtonLabel": "Join waitlist"
      },
      "pending": {
        "title": "Upgrade your travel class",
        "detail": "Get more perks, space and meal options.",
        "ctaButtonLabel": "Check upgrade status"
      },
      "loading": {
        "ctaButtonLabel": "Check upgrade options",
        "loaderText": "loading starting price"
      },
      "priceSection": {
        "dividerText": "or",
        "perPerson": "/ person"
      },
      "cabinClassesModalButtonLabel": {
        "multipleAvailable": "Travel class differences",
        "onlyBusinessAvailable": "Business Class details",
        "onlyPremiumEconomyAvailable": "Premium Economy details"
      },
      "upgradePageLinkLabel": "Read more",
      "aviosUpsellLinkLabel": "See how many Avios you need",
      "loginPopupButtonLabel": "Log in to your Finnair Plus account"
    }
  },
  "reaccommodation": {
    "ticketSelection": {
      "originalBounds": {
        "originalDepartureHeader": "Original departure flight",
        "originalReturnHeader": "Original return flight"
      }
    }
  }
}
